import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {
  setCameFromPage,
  toggleSelectionFeatureInfo
} from "../../../actions/actionFunctions";

import {UserPopupTypes} from "../../visComponents/constants";
import Analytics from "../../../analytics";
import {getFeatureIsLocked, toFixedFeatureCost} from '../../../misc/helpers';
import FeatureThumbnail from "../../visComponents/featureThumbnail";
import FeatureName from "../../visComponents/featureName";
import FeatureCartItemsCount from "../featureCartItemsCount";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";
import Config from "../../../config";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
// import MaterialsWizardAddToCartAndSkipButton
//   from "../../qkbPages/materialsWizard/materialsWizardAddToCartAndSkipButton";

class SelectionGridItem extends Component {

  static propTypes = {
    currentFeature: PropTypes.object.isRequired,
    handleFeatureClick: PropTypes.func.isRequired,
    checkIfFeatureSelected: PropTypes.func.isRequired,
    styles: PropTypes.object.isRequired,
    handleUserLoginClick: PropTypes.func.isRequired,
    isWizard: PropTypes.bool,
    wizardGroup: PropTypes.shape(wizardGroupInterface),
  };

  // handleInfoClick = () => {
  //   const {isPhoneNumberValidated, fabricatorData, currentFeature, handleUserLoginClick} = this.props;
  //   const fabricatorSettings = fabricatorData.settings;
  //
  //   if ((fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && (!currentFeature.part.dbFeature.unlocked && !isPhoneNumberValidated)){
  //     handleUserLoginClick();
  //   } else {
  //     toggleSelectionFeatureInfo(currentFeature.part);
  //   }
  // };

  goToFeatureInfo = () => {
    const propsFeature = this.props.currentFeature.part;
    const featureInfo = (propsFeature.partId === "shower_pan_combo"
      && (document.kvConfig.visualizerType === "bvScene" || document.kvConfig.visualizerType === "bvLook"))
      ? propsFeature.getParent().activeFeature
      : propsFeature;
    this.props.toggleSelectionFeatureInfo(featureInfo);
    this.props.setCameFromPage("materials"); // no more visualizer or shoppingcart switch
  };

  render() {

    const {currentFeature, fabricatorData, isPhoneNumberValidated, styles, showAdvancedQuoting, qtActiveCategory, intl,
      language, isWizard, wizardGroup} = this.props;
    const selected = this.props.checkIfFeatureSelected(currentFeature.part);
    const fabricatorSettings = this.props.fabricatorData.settings;
    const featureIsLocked = getFeatureIsLocked(currentFeature.part);

    const wizardSkipAndAddToCartButtonVisible = isWizard && wizardGroup && wizardGroup.skipProductInfo;

    const getQuoteEnabled = fabricatorSettings.enableQuote && !featureIsLocked;
    const quoteOrUnlockButtonVisible = (featureIsLocked || (getQuoteEnabled && !isPhoneNumberValidated))
      && !wizardSkipAndAddToCartButtonVisible;

    const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !featureIsLocked && !fabricatorData.hidePricesFromUser;

    const isAddToCartButtonVisible = selected && fabricatorSettings.showPricing && !featureIsLocked && !quoteOrUnlockButtonVisible && !showAdvancedQuoting
      && !wizardSkipAndAddToCartButtonVisible;

    const infoButtonVisible = !wizardSkipAndAddToCartButtonVisible;

    const price = toFixedFeatureCost(currentFeature.part, 1, qtActiveCategory);

    return (
      <div className={"feature" + (selected ? " feature--selected" : "")
      + (currentFeature.part.isStoneFeature ? " feature--stone" : "")}
           style={styles}
           onClick={(event) => this.props.handleFeatureClick(currentFeature, event)}
           onDoubleClick={infoButtonVisible ? this.goToFeatureInfo : null}>
        <FeatureThumbnail feature={currentFeature.part}/>
        {currentFeature.part.vanitySize ?
          <span className="feature-size">{currentFeature.part.vanitySize}"</span> : null
        }
        <FeatureCartItemsCount currentFeatureId={currentFeature.part.dbFeature.id}/>
        {selected ? (
          <div className="feature-buttons">
            {isAddToCartButtonVisible ? (
              <button className="feature-add-to-cart"
                      onClick={this.goToFeatureInfo}>
                <FormattedMessage id="quotingTool.feature.addToCart1"/> <span className="feature-add-to-cart__to-cart">
                  {fabricatorData.isLowes || language === "es-ES" ? null : <FormattedMessage id="quotingTool.feature.addToCart2"/>}
                </span>
              </button>
            ) : null}
            {/*{wizardSkipAndAddToCartButtonVisible*/}
            {/*  ? <MaterialsWizardAddToCartAndSkipButton feature={currentFeature.part}/>*/}
            {/*  : null}*/}
            {quoteOrUnlockButtonVisible ? (
              <button className={"feature-buttons__unlock ui-button2 ui-button2--green" + (getQuoteEnabled ? " ui-button2--getquote" : "")}
                      onClick={() =>Analytics.sendClickEvent((getQuoteEnabled ? 'feature-get-quote-' : 'feature-unlock-') + currentFeature.part.partName)
                        && this.props.handleUserLoginClick(
                          getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                        )} id='btnUnlockSelectionMainListItem'>
                {getQuoteEnabled ? (
                  <Fragment>
                    <span><FormattedMessage id="quotingTool.feature.getQuote1"/></span> <span><FormattedMessage id="quotingTool.feature.getQuote2"/></span>
                  </Fragment>
                ) : <FormattedMessage id="quotingTool.feature.unlockButton"/>}
              </button>
            ) : null}
            {infoButtonVisible ? <span className="feature-info" onClick={this.goToFeatureInfo}/> : null}
          </div>
        ) : null}
        {/*{currentFeature.part.notAvailableInVisualizer ? (*/}
        {/*<span className="feature-not-available">Not in Visualizer</span>*/}
        {/*) : null}*/}
        <div className={"feature-text"
        + (featureIsLocked ? " feature-text--locked" : " feature-text--unlocked")
        + (currentFeature.part.notAvailableInVisualizer && (!fabricatorData.isCaesarStone || Config.isDevMode()) ? " feature-text--not-in-visualizer" : "")}>
          {showPrice ? (
            <span className="feature-text__price">
              {getPriceWithIncluded(price, currentFeature.part, fabricatorData, intl.messages)}
            </span>
          ) : null}
          {featureIsLocked ? null : <span className="feature-text__name"><FeatureName feature={currentFeature.part}/></span>}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {language} = store.serverState;
  return {
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    fabricatorData: store.fabricatorState,
    filterGroups: store.filterState.filterGroups,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    qtActiveCategory: store.qtState.qtActiveCategory,
    language,
  };
};

const mapDispatchToProps = {
  toggleSelectionFeatureInfo,
  setCameFromPage
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SelectionGridItem)
);
